export const dealerDataMap = {
  dealerData: 'window.LEXUS.dealerData'
}

const serviceParser = (text, replaceWith) => {
  if (!text) return '';
  const regex = /{.+?}/gm;

  function replacer(match) {
    let keyFound = false;
    for (const key in replaceWith) {
      const replaceThis = `{${key}`;
      let replaced = match.search(replaceThis) >= 0;
      if (replaced) {
        match = match.replace(new RegExp(replaceThis, 'g'), replaceWith[key]);
        match = match.replace('}', '');
        keyFound = true;
      }
    }
    if (keyFound) {
      return eval(match); // NOSONAR but let's replace this
    } else {
      return match;
    }
  }
  return text.replace(regex, replacer);
}

export default serviceParser;